/*
 * Panorama Studios
 */
 
$(document).ready(function () {
	var baseUrl = (window.baseUrl || '/');

	// Responsive menu
	$('header nav').each(function () {
		var element = $(this);
		var responsiveNav = $('.responsive-nav');
		var toggler = $(
			'<div class="toggler">' +
				'<svg width="60px" height="60px" viewBox="0 0 450 250">' +
					'<path d="M50,32 C50,32 270,32 290,32 C490,32 390,352 270,232 C190,152 50,12 50,12" id="top"></path>' +
					'<path d="M50,132 L290,132" id="middle"></path>' +
					'<path d="M50,22 C50,22 270,22 290,22 C490,22 390,342 270,222 C190,142 50,2 50,2" id="bottom" transform="translate(292, 132) scale(1, -1) translate(-292, -130)"></path>' +
				'</svg>' +
				'<span>Menu</span>' +
			'</div>'
			).click(function () {
				responsiveNav.toggleClass('collapsed');
				$(document.body).toggleClass('nav-open');
				toggler.toggleClass('cross');
			}).appendTo(element);
	});

	// Header affix
	$('header').each(function () {
		var element = $(this);
		element.headroom({
			offset: element.outerHeight()
		});
		$(document.body).addClass('headroom--enabled');
	});

	// Lightbox
	var lightGalleryOptions = {
		selector: '.lightbox',
		download: false,
		thumbnail: false,
		fullScreen: false
	};
	$('#container').lightGallery(lightGalleryOptions);

	// Slideshows
	$('.slideshow-hero').each(function () {
		var element = $(this);
		var cssClass = element.attr('class');
		if (element.children('div').length > 1) {
			element.lightSlider({
				mode: 'fade',
				speed: 1000,
				auto: true,
				loop: true,
				pause: 5000,
				controls: false,
				pager: false,
				keyPress: true,
				addClass: cssClass
			});
		}
		element.children('div').addClass('showing');
	});

	$('.slideshow-text, .slideshow-textpage').each(function () {
		var element = $(this);
		var cssClass = element.attr('class');
		if (element.children('a, li').length > 1) {
			element.lightSlider({
				slideMargin: 0,
				mode: 'fade',
				loop: true,
				auto: true,
				speed: 1000,
				pause: 7000,
				pager: true,
				controls: false,
				addClass: cssClass,
				item: 1
			});
		}
	});

	// Slider
	$('.slider').each(function () {
		var element = $(this);
		var cssClass = element.attr('class');

		if (element.children('li').length > 7) {

			var slider = element.lightSlider({
				slideMargin: 0,
				loop: true,
				auto: true,
				speed: 800,
				pause: 4000,
				item: 7,
				pager: false,
				controls: false,
				addClass: cssClass,
				responsive: [{
					breakpoint: 1900,
					settings: {
						item: 6,
						slideMove: 1
					}
				}, {
					breakpoint: 1500,
					settings: {
						item: 5,
						slideMove: 1
					}
				}, {
					breakpoint: 1280,
					settings: {
						item: 4,
						slideMove: 1
					}
				}, {
					breakpoint: 1024,
					settings: {
						item: 2,
						slideMove: 1
					}
				}, {
					breakpoint: 640,
					settings: {
						item: 1,
						slideMove: 1
					}
				}]
			});

			$('.members .slider-wrapper').each(function () {
				var wrapper = $(this);
				wrapper.append('<div class="lSAction"><a class="lSPrev"></a><a class="lSNext"></a></div>');
				wrapper.find('.lSPrev').click(function () {
					slider.goToPrevSlide();
				});
				wrapper.find('.lSNext').click(function () {
					slider.goToNextSlide();
				});
			});
		}
	});

	// Infinite scrolling
	$('.images .item-container, .news .item-container').each(function () {
		var overview = $(this),
			pager = overview.find('+ .pager');

		if (pager) {
			pager.appendTo(overview);

			// Wrap contents to prevent scrolling on click
			overview.contents().wrapAll('<div class="jscroll-inner" />');

			var pagerLink = pager.find('a');
			pagerLink.one('click', function (e) {
				// Create loading pager
				var loading = $('<div>').append(pager.clone().addClass('loading'));
				loading.find('a').text(pagerLink.data('loading-text')).attr('href', null);

				// Add infinite scrolling
				overview.jscroll({
					debug: false,
					loadingHtml: loading.html(),
					padding: 400,
					nextSelector: '.pager a:last',
					pagingSelector: '.pager',
					callback: function () {
						var container = $('#container');
						container.data('lightGallery').destroy(true);
						container.lightGallery(lightGalleryOptions);
					}
				});

				// Trigger scroll event, so next page is directly loaded
				$(window).trigger('scroll');

				// Do not follow link
				e.preventDefault();
			});
		}
	});

	// File selector
	$(".file-upload").each(function () {
		var element = $(this).addClass('active');
		var input = element.find('input');
		var fileText = element.find('.file-upload-text');


		input.change(function () {

			var filename = input.val();
			if (filename != '') {
				fileText.text(filename);
			}
		});
	});

	// Change target for external sites
	var getDomainName = function (hostName) {
		return hostName.substring(hostName.lastIndexOf(".", hostName.lastIndexOf(".") - 1) + 1);
	};
	$('a:not([target])').filter(function () {
		var link = $(this),
			rel = link.attr('rel');

		if (rel && rel.contains('external', ' ')) return true; // Link rel attribute contains 'external'

		var href = link.attr('href');
		if (new RegExp('\.pdf$', 'i').test(href)) return true; // Link to PDF file

		if (new RegExp('^https?://', 'i').test(href)) {
			var linkHostName = getDomainName(href.substring(href.indexOf('/') + 2, href.indexOf('/', 8)));
			if (!new RegExp('(^|\.)' + getDomainName(document.location.hostname) + '$', 'i').test(linkHostName)) {
				// Link is to different domain name
				return true;
			}
		}

		return false;
	}).attr('target', '_blank');
});